import axios from "axios";
/**
 * 获取登记单信息
 */
export const fetchRegistrationInfo = async <T>(params: { uid: string }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/publishing-house/get-registration-form-info",
    params
  );
  return result.data;
};

/**
 * 个人中心-获取登记单list
 *
 */
export const fetchRegistrationList = async <T>(params: { uid: string }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/registration-form-list",
    params
  );
  return result.data;
};

/**
 * 注册单-提交登记单
 *
 */
export const submitRegistrationInfo = async <T>(params: { uid: string }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/publishing-house/submit-registration-form",
    params
  );
  return result.data;
};
